import React from 'react';
import SortableList, { SortableItem } from "react-easy-sort";
import ActionComponent from '../../pages/Activity/Component/ActionComponent';
import './Grid.css';

const Grid = ({ items, columns , enableCustom = false, callSort}) => {
    return (        
        <SortableList
            allowDrag={enableCustom}
            onSortEnd={callSort}
            className='list-grid'
            draggedItemClassName="dragged"
            style={{ gridTemplateColumns: `repeat(${columns}, 1fr)`}}
        >
            {items.map((action, index) => {
                return (
                    <SortableItem key={action.id} index={index}>
                        <div className="item-grid">
                            <ActionComponent
                                key={index}
                                action={action}
                                custom={enableCustom}
                            />
                        </div>
                    </SortableItem>
                );
            })}
        </SortableList>
    );
};

export default Grid;
